/* globals cpac, $, $j, showResources */

if (typeof cpac !== 'undefined') {
  cpac.invoices = {
    stop_script: false,
    start_number: 0,
    count: 20,
    step: 11,   // progress bar step
    current: 0,
    
    maxHeight: 1080, // + 40px for paging
    pagingHeight: 40, 
    pagingTop: 1092, //10.815,
    pageHeight: 1090, //10.815,
  
  tableName: 'statement_table',
  idPostfix: '',
    
    form: false,
    url: '',
    divId: '',
    
    startSearch: function (form, url, divID) {
        $j('#progress #progress_status').text('Creating Statements:');
        cpac.invoices.start_number = 0; 
        cpac.invoices.stop_script = false;
        if ($('order').value != 'id' || $('pdf_hidden').value == 1 || $('csv_hidden').value == 1) {
            cpac.invoices.stop_script = true;
        }
        cpac.invoices.current = 0;
        cpac.invoices.updateProgressBar();
        cpac.invoices.showResources(form, url, divID);
        window.scrollTo(0, 0);
    }, 
    
    stopSearch: function() {
        $j('#progress #progress_status').text('Cancelling');
        cpac.invoices.stop_script = true;
    },
    
    updateProgressBar: function() {        
        $j('#progress .progress-bar').css({width: this.current * this.step});
    },
    
    proceedRequest: function (request) {
        $j('#report_table_total').remove();
  
        var totalValues = [0, 0, 0, 0, 0];
  
        $j('#report_table .transaction_row').each(function() {
            for (var i = 0; i < totalValues.length; i++) {
                totalValues[i] += parseFloat($j(this).find('td').eq(i + 3).text().replace(',', ''));
                totalValues[i] = Math.round(totalValues[i] * 100) / 100;
            }
        });
  
        var totalHtml = '<tbody id="report_table_total"><tr><th colspan="3">Total</th>';
        for (var j = 0; j < totalValues.length; j++) {
            totalHtml += '<th class="right">' + totalValues[j].toFixed(2) + '</th>';
        }
        totalHtml += '<th>&nbsp;</th></tr></tbody>';
  
        $j('#report_table tbody:last').after(totalHtml);
  
        if (request.responseText != '' && !cpac.invoices.stop_script) {
            $j('#progress').show();
            cpac.invoices.current ++;
            cpac.invoices.updateProgressBar();
            cpac.invoices.start_number = cpac.invoices.start_number + cpac.invoices.count;
            showResources(cpac.invoices.form, cpac.invoices.url, 'report_table', cpac.invoices.proceedRequest, 'processing=1&doFilter=1&start_number='+cpac.invoices.start_number, true, 'post', 'append');
        }
        else {
            $j('#progress').hide();
            cpac.invoices.stop_script = true;
        }    
    },
    
    showResources: function(form, url, divID) {
        this.form = form;
        this.url = url;
        this.divId = divID;
        
        $j('#progress').show();
  
        showResources(form, url, divID, cpac.invoices.proceedRequest, '', true);
    },
    
    sort_table_for_pdf: function(id,div_id,width,statement_note) {
        var header_top = parseFloat($j('#' + div_id).position().top);
        var header_height = $j('#' + div_id + ' #letter-head').height();
        var stament_note_height = $j('#'+statement_note).height();
        var NewTable = document.createElement('table');
        var max_height = this.maxHeight;
        var height = header_height + stament_note_height;
        
        var TRs = $j('#'+id).children('tbody').children();
        var OldTable = $j('#'+id);
    this.idPostfix = id.substr(this.tableName.length);
        var Thead = $j('#table_head' + this.idPostfix);
        var colCnt = 1;
        var pagePositions = new Array();
        pagePositions[0] = header_top;
        
        var totalPages = 1;
        
  
        NewTable.setAttribute('id', 'statement_table');
        NewTable.setAttribute('cellspacing', '0');
        NewTable.setAttribute('cellpadding', '5');
        $j(NewTable).css('width', width);
        NewTable.className = 'items_list';
        var NewThead = Thead.clone();
        NewTable.appendChild(NewThead[0]);
  
        var NewTbody = document.createElement('tbody');
        NewTable.appendChild(NewTbody);
        
        
  
        $j.each(TRs, function(key, value) {
            var thisHeight = parseFloat($j(value).height());
            
            if ((height + thisHeight) >= max_height) {
                colCnt = this.childNodes.length;
                // add tr for paging (otherwise it gets cut into parts)
                var pageNumTr = document.createElement('tr');
                var pageNumTd = document.createElement('td');
                pageNumTd.setAttribute('colspan', colCnt);
                pageNumTd.setAttribute('height', (cpac.invoices.pageHeight - height) + 'px');
                //  pageNumTd.setAttribute('style', 'border: 1px dotted orange;');
                //    pageNumTd.innerHTML = 'max: ' + max_height + ' height: ' + height + ' this: ' +pageNumTd.getAttribute('height');
                pageNumTr.appendChild(pageNumTd);
                NewTbody.appendChild(pageNumTr);
             
                $j(NewTable).insertBefore(OldTable);
                if (pagePositions[totalPages - 1] == undefined) {
                    pagePositions[totalPages - 1] = $j(NewTable).position().top;
                }
                
                NewTable = document.createElement('table');
                NewTable.setAttribute('id', 'statement_table');
                NewTable.setAttribute('cellspacing', '0');
                NewTable.setAttribute('cellpadding', '5');
                NewTable.className = 'items_list';
                $j(NewTable).css('page-break-before', 'always');
                $j(NewTable).css('width', width);
                NewThead = Thead.clone();
                NewTable.appendChild(NewThead[0]);
                NewTbody = document.createElement('tbody');
                NewTable.appendChild(NewTbody);
                height = 0;
                
                
                
                totalPages ++;
            }
             
            if (value.tagName != 'THEAD') {
                NewTbody.appendChild(value);
            }
             
            height = height + thisHeight;
        });
        
        
        
        $j(NewTable).insertBefore(OldTable);
        if (pagePositions[totalPages - 1] == undefined) {
            pagePositions[totalPages - 1] = $j(NewTable).position().top;
        }
        var subtotal_height = $j('#' + div_id + ' #total').height();
        //alert(height+'|'+subtotal_height+'|'+max_height);
        if ((height+subtotal_height) > max_height) {
            var pageNumTr = document.createElement('tr');
            var pageNumTd = document.createElement('td');
            pageNumTd.setAttribute('colspan', colCnt);
            pageNumTd.setAttribute('height', (max_height - height) + 'px');
            //    pageNumTd.setAttribute('style', 'border: 1px dotted orange');
            pageNumTr.appendChild(pageNumTd);
            NewTbody.appendChild(pageNumTr);
          
            //$j('#' + div_id + ' #total').css('page-break-before', 'always');
            totalPages ++;
        }
        
        OldTable.html('');
        
        
        // add paging
        var lastPage = null;
        var divTop = header_top;
        for (var i=0; i < totalPages; i++) {
            var pageTitle = document.createElement('div');
            pageTitle = $j(pageTitle);
            
            let method = 0;
            let las = 0;
            if (pagePositions[i] != undefined) {
                divTop = pagePositions[i] + this.pagingTop;
                method = 1;
            } else if (lastPage != null) {
                divTop = $j(lastPage).position().top + this.pageHeight + 20;
                las = $j(lastPage).position().top;
                method = 2;
            } else {
                divTop = this.pageHeight * i + this.pagingTop;
                method = 3;
            }
            var cssParams = {
                position: 'absolute', 
                'padding-top': '10px', 
                top: (divTop + 'px'), 
                'text-align': 'center', 
                width: width
            };
            pageTitle.css(cssParams);
            var pageNum = i + 1;
            
            pageTitle.html('Page ' + pageNum + ' / ' + totalPages); // + ' method: ' + method + ' top: ' + divTop + ' last: ' + las);
            //pageTitle.html('Page <span cid="curr_page">#</span> / <span cid="total_page">#</span>');
            $j('#' + div_id).append(pageTitle);
            lastPage = pageTitle;
        }
        
            // adjust container height so that page number won't be on the next member's invoice
        var containerHeight = $j('#' + div_id).height();
        // $j('#' + div_id).css({border: '1px solid red'});
        if (header_top + containerHeight < divTop + $j(lastPage).outerHeight()) {
            $j('#' + div_id).height(divTop + $j(lastPage).outerHeight() - header_top);
        }
    }    
    
  }
}